exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blurb{max-width:1200px}.blurb-header{font:600 20px Poppins;color:#232323;text-decoration:none solid #232323}.blurb-body{max-width:700px !important}@media(min-width: 900px){.blurb-body{padding-right:5px !important}}.blurb-content{max-width:700px;padding:5%;margin:0 auto}@media(min-width: 576px){.blurb-content{padding-top:40px !important}}@media(min-width: 900px){.blurb-content{padding-right:1%;padding-left:50px !important}}@media(min-width: 768px){.blurb-content{padding-left:50px !important;margin-top:1%}}", ""]);

// exports
